import {getScaledNumber} from '@/Pages/Common/Utils';
import {RegionalCostsVehicleCost} from '@/Pages/RegionalCosts/store/types';
import {PartnerCostsVehicleCost} from '@/Pages/PartnerCosts/store/types';
import {VehicleCostFieldConfig} from './VehicleCostsTable.types';

interface VehicleCostTableRowConfig {
  title: string;
  originalValue: string | null;
  fallbackValue: string | null;
}

function getRawFallback(
  rowConfig: VehicleCostFieldConfig,
  fallbackConfigs: VehicleCostFieldConfig[] | undefined,
  fallbackVehicleCost: RegionalCostsVehicleCost | undefined
): string | null {
  if (!fallbackVehicleCost || !fallbackConfigs) return null;

  const originalKey = rowConfig.key;
  if (
    rowConfig.key === 'repairCostPerMonth' ||
    rowConfig.key === 'repairCostPerDistanceUnit'
  ) {
    const fallbackConfig = fallbackConfigs.find(({key}) =>
      ['repairCostPerDistanceUnit', 'repairCostPerMonth'].includes(key)
    );
    // If it happens - we have a bug
    if (!fallbackConfig) {
      console.error('No matched config for the repair cost fallback');
      return null;
    }

    const rawFallback = fallbackVehicleCost[fallbackConfig.key];
    if (typeof rawFallback !== 'number') return null;

    const fallbackValue = getScaledNumber(
      String(rawFallback),
      fallbackConfig.fractionDigitsCount
    );
    return originalKey === fallbackConfig.key
      ? fallbackValue
      : `${fallbackValue} (${fallbackConfig.unit})`;
  } else {
    const rawFallback = fallbackVehicleCost[originalKey];
    return getScaledNumber(String(rawFallback), rowConfig.fractionDigitsCount);
  }
}

export function getVehicleCostTableRowConfig(
  rowConfig: VehicleCostFieldConfig,
  vehicleCost: RegionalCostsVehicleCost | PartnerCostsVehicleCost,
  fallbackConfigs: VehicleCostFieldConfig[] | undefined,
  fallbackVehicleCost: RegionalCostsVehicleCost | undefined
): VehicleCostTableRowConfig {
  const title = `${rowConfig.name} (${rowConfig.unit})${
    rowConfig.mandatory ? '*' : ''
  }:`;

  const rawOriginal = vehicleCost[rowConfig.key];
  const originalValue =
    typeof rawOriginal === 'number'
      ? getScaledNumber(String(rawOriginal), rowConfig.fractionDigitsCount)
      : '—';

  const fallbackValue = getRawFallback(
    rowConfig,
    fallbackConfigs,
    fallbackVehicleCost
  );

  return {title, originalValue, fallbackValue};
}
